
import { reactive} from "vue";
import DynamicForm from "@/components/Shared/Dynamicform/DynamicForm.vue";

export default {
  name: "WildBookEntryCoordinates",
  inheritAttrs: false,
  components: {
    DynamicForm
  },
  setup() {
    const request = reactive({
      apiLoadMethod: "api/Form/loadForm",
      apiSaveMethod: "",
      form: "WildbuchEintragJagd",
      page: "WildbuchEintragLokalisierungJagd",
      remoteId: "",
      waitForResponse: true,
      geoEditMode: "New",
      geoGpsMode: "OnStartup",
      geoDisplayClass: "additional",
      geoCheckInsidePolygon: true,
      

      

    });
    return {
      request
    };
  }
};
